<script lang="ts">
	export let width: number
</script>

<div class="col-span-{width}" />
